import(/* webpackMode: "eager" */ "/app/src/app/admin/login/page.tsx");
